<template>
  <div>
    <div id="patrolTaskNumChart"></div>
  </div>
</template>

<script>
import Echarts from "echarts";
export default {
  name: "patrolTaskNumChart",
  components: {},
  props: {
    echartsData: {
      type: Array,
      default: {
        return: []
      }
    }
  },
  data() {
    return {
      myChart: {}
    };
  },
  created() {},
  mounted() {
    let _this = this;
    // window.onresize = function () {
    //   _this.myChart.resize();
    // };
  },
  created() {},
  mounted() {
    this.$nextTick(() => {
      this.loadEchart();
    });
  },
  computed: {},
  watch: {
    echartsData: function(newVal) {
      this.loadEchart();
    }
  },
  methods: {
    loadEchart() {
      this.myChart = Echarts.init(
        document.getElementById("patrolTaskNumChart")
      );
      let option = {
        title: {
          // text: "折线图堆叠",
        },
        tooltip: {
          show: true,
          trigger: "axis",
          axisPointer: {
            // 坐标轴指示器，坐标轴触发有效
            type: "shadow" // 默认为直线，可选为：'line' | 'shadow'
          },
          formatter: "{b}<br />{a0} : {c0}%<br />{a1} : {c1}",
          textStyle:{
            align:'left'
            }
        },
        legend: {
          show: true,
          itemWidth: 14,
          itemHeight: 14,
          bottom: "bottom",
          textStyle: {
            color: "#B4BBE0"
          },
          data: ["巡查率", "巡查任务数"]
        },
        grid: {
          top: "1%",
          left: "3%",
          right: "12%",
          bottom: "10%",
          containLabel: true
        },
        toolbox: {
          // feature: {
          //   saveAsImage: {},
          // },
        },
        xAxis: {
          type: "value",
          // nameTextStyle: {
          //   color: "#B4BBE0",
          //   fontSize: 14
          // },
          axisTick: {
            show: false
          },
          axisLabel: {
            show: false,
            textStyle: {
              color: "#B4BBE0",
              fontSize: "14"
            }
          },
          boundaryGap: false,
          axisLine: {
            show: false,
            lineStyle: {
              color: "#4868AF",
              type: "dash",
              opacity: 0.5,
              fontSize: 14
            }
          },
          splitLine: {
            show: false,
            lineStyle: {
              color: ["#4868AF"],
              width: 1,
              type: "dash",
              opacity: 0.1
            }
          }
        },
        yAxis: {
          type: "category",
          nameTextStyle: {
            color: "#B4BBE0",
            fontSize: 14
          },
          axisTick: {
            show: false
          },
          axisLabel: {
            show: true,
            textStyle: {
              color: "#C4CDFF",
              fontSize: "16"
            },
            formatter: function(params) {
              var newParamsName = ""; // 最终拼接成的字符串
              var paramsNameNumber = params.length; // 实际标签的个数
              var provideNumber = 4; // 每行能显示的字的个数
              if (paramsNameNumber > provideNumber) {
                newParamsName =
                  params.substring(0, provideNumber) + "...";
              } else {
                newParamsName = params;
              }
              return newParamsName;
              // 　　var rowNumber = Math.ceil(paramsNameNumber / provideNumber);// 计算行数，向上取整
              // 　　//判断是否需要换行
              // 　　if (paramsNameNumber > provideNumber) {
              // 　　　　//循环得到每行的显示内容，p代表行
              // 　　　　for (var p = 0; p < rowNumber; p++) {
              // 　　　　　　var tempStr = "";// 表示每一次截取的字符串
              // 　　　　　　var start = p * provideNumber;// 开始截取的位置
              // 　　　　　　var end = start + provideNumber;// 结束截取的位置
              // 　　　　　　if (p == rowNumber - 1) {
              // 　　　　　　　　// 最后一次不换行
              // 　　　　　　　　tempStr = params.substring(start, paramsNameNumber);
              // 　　　　　　} else {
              // 　　　　　　　　// 每一次拼接字符串并换行
              // 　　　　　　　　tempStr = params.substring(start, end) + "\n";
              // 　　　　　　}
              // 　　　　　　newParamsName += tempStr;// 最终拼成的字符串
              // 　　　　}
              // 　　} else {
              // 　　　　// 将旧标签的值赋给新标签
              // 　　　　newParamsName = params;
              // 　　}
              // 　　return newParamsName
            }
          },
          axisLine: {
            show: false,
            lineStyle: {
              // show: false,
              color: "#4868AF",
              type: "dash",
              opacity: 0.5
            }
          },
          splitLine: {
            show: false,
            lineStyle: {
              color: ["#4868AF"],
              width: 1,
              type: "dash",
              opacity: 0.1
            }
          }
        },
        series: [
          {
            data: [],
            name: "巡查率",
            type: "bar",
            barWidth: "8",
            label: {
              normal: {
                show: true,
                color: "#FFFFFF",
                position: "right",
                formatter: "{c}%" // 这里是数据展示的时候显示的数据
              }
            },
            itemStyle: {
              // width: 2.5,
              shadowColor: "rgba(255, 255, 255, 0.5)",
              shadowBlur: 6
            }
          },
          {
            data: [],
            name: "巡查任务数",
            type: "bar",
            barWidth: "8",
            itemStyle: {
              // width: 2.5,
              shadowColor: "rgba(255, 255, 255, 0.5)",
              shadowBlur: 6
            },
            label: {
              normal: {
                show: true,
                color: "#FFFFFF",
                position: "right",
                formatter: "{c}" // 这里是数据展示的时候显示的数据
              }
            }
          }
        ],
        color: ["#FEFF50", "#1890FF"]
      };
      let newList = JSON.parse(JSON.stringify(this.echartsData)).reverse();
      option.yAxis.data = newList.map((item) => {
        return item.nameRiskPoint;
      });
      option.series[0].data = newList.map((item) => {
        return item.inspectRiskPoint || 0;
      });
      option.series[0].barWidth = (7 - option.series[0].data.length) * 5;
      option.series[1].data = newList.map((item) => {
        return item.numberJobs || 0;
      });
      option.series[1].barWidth = (7 - option.series[1].data.length) * 5;
      this.myChart.setOption(option);
    }
  },
  destroyed() {}
};
</script>

<style lang="scss" scoped>
#patrolTaskNumChart {
  width: 100%;
  height: 350px;
}
</style>
